import { render, staticRenderFns } from "./MyGameAccountsList.vue?vue&type=template&id=be091ec2&scoped=true&"
import script from "./MyGameAccountsList.vue?vue&type=script&lang=ts&"
export * from "./MyGameAccountsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be091ec2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItemTitle,VSpacer,VSubheader})
